import React from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { SiteTransitions } from '../../../utils/transitions';
import PipsNav from './Nav/PipsNav';

import { Outlet } from 'react-router';

import PipsFooter from './Footer/PipsFooter';
import PipsMerchNotice from './Body/PipsMerchNotice';


const PipsMain: React.FC = () => {
    return (
        <motion.div
            variants={SiteTransitions}
            initial='initial'
            animate='animate'
            exit='exit'
            className='flex flex-col size-full'
        >
            <PipsNav />
            <main
                className='grow flex flex-col text-garamond'
            >
                <AnimatePresence mode='wait'>
                    <Outlet />
                </AnimatePresence>
                <PipsMerchNotice />
            </main>
            <PipsFooter />
        </motion.div>
    )
}

export default PipsMain;